import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    storeVehiculeAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/store`, payload)
          .then((res) => {
            resolve(res.data.vehicule);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    searchVehiculesAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/search`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateVehiculeAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/vehicule/update/${payload.get("vehicule_id")}`, payload)
          .then((res) => {
            resolve(res.data.vehicule);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteVehiculeAction(Context, vehiculeId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/vehicule/delete/${vehiculeId}`)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deletePhotoAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/delete-photo`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    reportVehiculesAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/report`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    countVehiculesAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/vehicule/counts`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    searchByParameterDashAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/search-dash`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findVehiculesAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/find-all`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findVehiculesAvailableAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/vehicule/find-available`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    desvinculeEmployeeVincule(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/desvincule-employee`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    vehiculeFindAdminAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/count-find-admin`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findCategoriesVehiculeAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/vehicule/find-categories`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};

export default store;
